module.exports = __webpack_public_path__ + "static/media/wandelen_door_d_duinen.4abd427c.jpg";